import React, { useState, useEffect } from 'react'
import { VerifiedDomainNames } from '../lib/types'
import { checkDomain } from '../lib/api'
import { generateDomains, redirectToBuyDomain, tlds } from '../lib/utils'
import { FaCheckCircle } from 'react-icons/fa'
import { FaCircleXmark } from 'react-icons/fa6'

type Props = {
  domainName: string
}

const DomainNamesList: React.FC<Props> = ({ domainName }) => {
  const [domainNamesList, setDomainNamesList] = useState<VerifiedDomainNames[]>([])

  const fetchDomainNames = async (domainName: string) => {
    const domainsList: VerifiedDomainNames[] = []
    const response = await checkDomain(domainName, tlds)
    const data = response.data
    const { Domain: domains, RRPCode: repCodes } = data
    if (domains && domains.length > 0) {
      for (let index = 0; index < domains.length; index++) {
        const domainName = domains[index];
        domainsList.push({
          domainName,
          isRegistered: parseInt(repCodes[index]) !== 210
        })
      }
    }
    setDomainNamesList(domainsList)
  }

  const initializeDomains = () => {
    let verifiedDomains: VerifiedDomainNames[] = []
    const domains = generateDomains(domainName)
    verifiedDomains = domains.map((domain) => {
      return {
        domainName: domain,
        isRegistered: false
      }
    })
    setDomainNamesList(verifiedDomains)
  }

  useEffect(() => {
    setDomainNamesList([])
    fetchDomainNames(domainName)
  }, [domainName])

  useEffect(() => {
    initializeDomains()
  }, [])

  const getBorderClass = (item: VerifiedDomainNames) => {
    return item.isRegistered ? "border-light-subtle" : "border-primary-subtle"
  }

  const onBuyNowClick = (domainName: string) => {
    redirectToBuyDomain(domainName)
  }
  
  return (
    <>
      {/* <div className='text-center'>
        <h5>Domains</h5>
      </div> */}
      <div className="domainNamesListWrapper">
        {domainNamesList.map((item, index) => {
          return (
            <span key={index} className={`domainName p-2 border text-primary-emphasis m-3 ${getBorderClass(item)}`}>
              <span className="pe-2" style={{color:item.isRegistered? "pink" : "#4CAF50" }}>
                { item.isRegistered ? <FaCircleXmark /> : <FaCheckCircle />}
              </span>
              <span style={{color:item.isRegistered? "gray" : "#444" }}>
                {item.domainName}
              </span>
              { !item.isRegistered && <a className='btnRegister' onClick={() => onBuyNowClick(item.domainName)}>{"Buy Now"}</a> }
            </span>
          )
        })}
      </div>
    </>
  )
}

export default DomainNamesList
